import { render, staticRenderFns } from "./MailDocPreview.vue?vue&type=template&id=28f228e4&scoped=true&"
import script from "./MailDocPreview.vue?vue&type=script&lang=js&"
export * from "./MailDocPreview.vue?vue&type=script&lang=js&"
import style0 from "./MailDocPreview.vue?vue&type=style&index=0&id=28f228e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f228e4",
  null
  
)

export default component.exports